
import Vue from 'vue'
import layouts from '@/layouts/index.vue'
import { mapGetters } from 'vuex'
import { UserDataInterface } from '@/store/modules/user/types'
import { startChaportSession, markChaportAnonymous } from '@/utils/chaport'

function resolveChaportIdentity (userData: UserDataInterface, isAuthenticated: boolean): void {
  if (!isAuthenticated || !userData.visitor_hash || !userData.account_id) {
    markChaportAnonymous()
    return
  }

  const fullName = [
    userData.last_name,
    userData.first_name,
    userData.patronymic
  ].filter(Boolean).join(' ')

  startChaportSession({
    id: userData.account_id,
    token: userData.visitor_hash,
    visitorData: {
      name: fullName,
      email: userData.email,
      phone: userData.phone,
      custom: {
        uuid: userData.uuid
      }
    }
  })
}

export default Vue.extend({
  name: 'App',
  computed: {
    ...mapGetters('user', ['getUserData', 'getIsAuthenticated', 'getIsLoaded'])
  },
  watch: {
    getIsAuthenticated (v) {
      const vm = this as any
      if (v) {
        resolveChaportIdentity(vm.getUserData, true)
      }
    }
  },
  beforeCreate (): void {
    const setTrueVH = () => {
      const trueVH = window.innerHeight / 100
      document.body.style.setProperty('--tVH', trueVH + 'px')
    }
    setTrueVH()
    window.addEventListener('resize', setTrueVH)
  },
  mounted (): void {
    const vm = this as any
    if (vm.getIsAuthenticated) {
      resolveChaportIdentity(vm.getUserData, true)
    }
  },
  async created (): Promise<void> {
    const vm = this as any
    await vm.$store.dispatch('user/loadUser')
    // loadUser завершён: либо isAuthenticated=true (тогда identity уже выставлена
    // в watch/mounted), либо нет — Chaport должен запуститься как анонимный, иначе
    // safety-timeout в initChaport отвалит его через 5 секунд.
    if (!vm.getIsAuthenticated) {
      markChaportAnonymous()
    }
    await vm.$store.dispatch('user/getUserProfiles')
    this.$store.dispatch('notifications/loadAll')
  },
  components: {
    layouts
  }
})
